import { Outlet } from 'react-router-dom';

import { horizontalLogo } from '../src/layoutAssets';

const LogoLayout = () => {
  return (
    <main className="min-h-screen">
      <div className="absolute transform left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <img src={horizontalLogo} alt="logo" className="max-w-sm mb-10" />
        <Outlet />
      </div>
    </main>
  );
};

export default LogoLayout;
